$(function() {
    var SwipesCarousel = new Swiper('.main__carousel', {
        a11y: false,
        loop:true,
        fadeEffect: { crossFade: true },
        effect: "fade",
        navigation: {
            nextEl: ".swiper-top-next",
            prevEl: ".swiper-top-prev",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        speed: 300,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });

    let intervalCarousel = setInterval(() => {
        var wdWidth = screen.width;
        var imgCarousel = document.querySelector(".main__carousel img.pc-display");
        if(wdWidth <= 768 ) {
            imgCarousel = document.querySelector(".main__carousel img.sp-display");
        }

        if(imgCarousel && imgCarousel.offsetHeight > 0) {
            $(".doneLoadSlider").removeClass('hidden');
            clearInterval(intervalCarousel);
        }
    });
    
    $('.slider_top').on('touchstart', function () {
        $(this).slick('slickPlay');
    });
});

$(function(){
    $(window).resize(function(){
        var width = $(window).width();
        if(width >= 769){
            $('.slider_topics').not('.slick-initialized').slick({
                arrows:true,
                slidesToShow: 5,
                slidesToScroll: 4,
                dots: true,
                autoplay: false,
                speed: 1500,
                centerMode: true,
                adaptiveHeight: true,
                initialSlide: 0,
                infinite: true,
                centerPadding: '5%',
                pauseOnHover: false,
                pauseOnFocus: false,
                responsive: [ {
                    breakpoint: 768,
                    settings: 'unslick'
                } ]            
            });
            $('.slider_topics').slick("slickSetOption", "slidesToScroll", 4, true);
        } else {
            $('.slider_topics .slide.slick-initialized').slick('unslick');
        }
    });
});



// $(function(){
//     function sliderSetting(){
//         var width = $(window).width();
//         if(width <= 769){
//             $('.styling_block').not('.slick-initialized').slick({
//                 autoplay: false,
//                 centerMode: false,
//                 arrows:false,
//                 infinite: false,
//                 dots:false,
//                 slidesToShow: 2.5,
//                 slidesToScroll: 2
//             });
//         } else {
//             $('.styling_block .slide.slick-initialized').slick('unslick');
//         }
//     }
//     sliderSetting();
//     $(window).resize(sliderSetting());
// });

// $(function(){
//     function sliderSetting(){
//         var width = $(window).width();
//         if(width <= 769){
//             $('.ranking_block').not('.slick-initialized').slick({
//                 autoplay: false,
//                 centerMode: false,
//                 arrows:false,
//                 infinite: false,
//                 dots:false,
//                 slidesToShow: 2.5,
//                 slidesToScroll: 2
//             });
//         } else {
//             $('.ranking_block .slide.slick-initialized').slick('unslick');
//         }
//     }
//     sliderSetting();
//     $(window).resize(sliderSetting());
// });

$(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width >= 769){
            $('.slider_news').not('.slick-initialized').slick({
                autoplay: false,
                centerMode: false,
                arrows:true,
                infinite: false,
                dots:false,
                slidesToShow: 5,
                slidesToScroll: 1,
                centerPadding: '0px',
            });
        } else {
            $('.slider_news .slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
});

$(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width <= 769){
            $('.slider_news_3').not('.slick-initialized').slick({
                autoplay: false,
                centerMode: false,
                arrows:true,
                infinite: true,
                dots:true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: '0px',
            });
        } else {
            $('.slider_news_3 .slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
});

$(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width <= 769){
            $('.slider_blog').not('.slick-initialized').slick({
                autoplay: false,
                centerMode: false,
                arrows:false,
                infinite: true,
                dots:false,
                slidesToShow: 2,
                slidesToScroll: 1,
                centerPadding: '0px',
            });
        } else {
            $('.slider_blog .slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
});

$(function() {
    var elm = $('.swiper-container');
    elm.each((index, element) => {
        var swiper = new Swiper('.' + $(element).data('id'), {
            slidesPerView: "auto",
            spaceBetween: 0.1,
            slidesPerView: 2.5,
            preloadImages: true,
            centeredSlides: false,
            loopedSlides: 2,
            noSwiping : false,
            a11y: false,
            navigation: {
                nextEl: '.next-button-' + $(element).data('id'),
                prevEl: '.prev-button-' + $(element).data('id')
            },
            enabled: false,
            breakpoints: {
                768: {
                    enabled: true,
                    slidesPerView: 5,
                }
            }
        });
        $(window).resize(function(){
            var ww = $(window).width();
            if (ww>764) {
                swiper.params.slidesPerView = 4.9;
                var prevarrow = $('.prev-button-' + $(element).data('id'))[0];
                var nextarrow = $('.next-button-' + $(element).data('id'))[0];


                prevarrow.style.display = 'none';
                nextarrow.style.display = 'block';
                swiper.on('slideChange', function() {
                    var realIndex = swiper.realIndex;
                    var activeIndex = swiper.slides.length - 5;
                    realIndex == 0 ? prevarrow.style.display = 'none' : prevarrow.style.display = 'block';
                    realIndex == activeIndex ? nextarrow.style.display = 'none' : nextarrow.style.display = 'block';
                });
            }
            if (ww<=764) {
                swiper.params.slidesPerView = $(element).data('sp-slideperview') || 2.5;
                swiper.params.spaceBetween = 0;
                var prevarrow = $('.prev-button-' + $(element).data('id'))[0];
                var nextarrow = $('.next-button-' + $(element).data('id'))[0];
                var realIndex = swiper.realIndex;
                var activeIndex = swiper.slides.length - 2;
                realIndex == 0 ? prevarrow.style.display = 'none' : prevarrow.style.display = 'block';
                realIndex == activeIndex ? nextarrow.style.display = 'none' : nextarrow.style.display = 'block';
               
                swiper.on('slideChange', function() {
                    prevarrow.style.display = 'none';
                    nextarrow.style.display = 'none';
                    var realIndex = swiper.realIndex;
                    var activeIndex = swiper.slides.length - 2;
                    realIndex == 0 ? prevarrow.style.display = 'none' : prevarrow.style.display = 'block';
                    realIndex == activeIndex ? nextarrow.style.display = 'none' : nextarrow.style.display = 'block';
                });
            }
            swiper.update();
        });
    });
    // recommendproduct 
    var elm2 = $('.swiper__recommendproduct');
    elm2.each((index, element) => {
        var swiper2 = new Swiper('.' + $(element).data('id'), {
            slidesPerView: "auto",
            spaceBetween: 0.1,
            slidesPerView: 2.5,
            preloadImages: true,
            centeredSlides: false,
            loopedSlides: 2,
            a11y: false,
            enabled: false,
            navigation: {
                nextEl: '.next-button-' + $(element).data('id'),
                prevEl: '.prev-button-' + $(element).data('id')
            },
            breakpoints: {
                768: {
                    enabled: true,
                    slidesPerView: 5,
                }
            }
        });
        $(window).resize(function(){
            var ww = $(window).width();
            if (ww>764) {
                swiper2.params.slidesPerView = 4.9;
                var prevarrow2 = $('.prev-button-' + $(element).data('id'))[0];
                var nextarrow2 = $('.next-button-' + $(element).data('id'))[0];

                if(ww <= 850) {
                    var realIndex2 = swiper2.realIndex;
                    var activeIndex2 = swiper2.slides.length - 5;
                    realIndex2 == 0 ? prevarrow2.style.display = 'none' : prevarrow2.style.display = 'block';
                    realIndex2 == activeIndex2 ? nextarrow2.style.display = 'none' : nextarrow2.style.display = 'block';
                }
                else{
                    prevarrow2.style.display = 'none';
                    nextarrow2.style.display = 'block';
                }
                swiper2.on('slideChange', function() {
                    var realIndex2 = swiper2.realIndex;
                    var activeIndex2 = swiper2.slides.length - 5;
                    realIndex2 == 0 ? prevarrow2.style.display = 'none' : prevarrow2.style.display = 'block';
                    realIndex2 == activeIndex2 ? nextarrow2.style.display = 'none' : nextarrow2.style.display = 'block';
                });
            }
            if (ww<=764) {
                swiper2.params.slidesPerView = $(element).data('sp-slideperview') || 2.5;
                swiper2.params.spaceBetween = 0;
                var prevarrow2 = $('.prev-button-' + $(element).data('id'))[0];
                var nextarrow2 = $('.next-button-' + $(element).data('id'))[0];
                var realIndex2 = swiper2.realIndex;
                var activeIndex2 = swiper2.slides.length - 2;
                realIndex2 == 0 ? prevarrow2.style.display = 'none' : prevarrow2.style.display = 'block';
                realIndex2 == activeIndex2 ? nextarrow2.style.display = 'none' : nextarrow2.style.display = 'block';

                    if(swiper2.slides.length <= 2) {
                        nextarrow2.style.display = 'none';
                    }

                swiper2.on('slideChange', function() {
                    prevarrow2.style.display = 'none';
                    nextarrow2.style.display = 'none';
                    var realIndex2 = swiper2.realIndex;
                    var activeIndex2 = swiper2.slides.length - 2;
                    realIndex2 == 0 ? prevarrow2.style.display = 'none' : prevarrow2.style.display = 'block';
                    realIndex2 == activeIndex2 ? nextarrow2.style.display = 'none' : nextarrow2.style.display = 'block';
                });
            }
            swiper2.update();
        });
    });

    // STAFF STYLING 
    var elm3 = $('.swiper__staffstyling');
    elm3.each((index, element) => {
        var swiper3 = new Swiper('.' + $(element).data('id'), {
            slidesPerView: "auto",
            spaceBetween: 0.1,
            slidesPerView: 2.5,
            preloadImages: true,
            centeredSlides: false,
            loopedSlides: 2,
            a11y: false,
            enabled: false,
            navigation: {
                nextEl: '.next-button-' + $(element).data('id'),
                prevEl: '.prev-button-' + $(element).data('id')
            },
            breakpoints: {
                768: {
                    enabled: true,
                    slidesPerView: 5,
                }
            }
        });
        $(window).resize(function(){
            var ww = $(window).width();
            if (ww>764) {
                swiper3.params.slidesPerView = 4.9;
                var prevarrow3 = $('.prev-button-' + $(element).data('id'))[0];
                var nextarrow3 = $('.next-button-' + $(element).data('id'))[0];

                prevarrow3.style.display = 'none';
                nextarrow3.style.display = 'block';

                if(ww <= 850) {
                    var realIndex3 = swiper3.realIndex;
                    var activeIndex3 = swiper3.slides.length - 5;
                    realIndex3 == 0 ? prevarrow3.style.display = 'none' : prevarrow3.style.display = 'block';
                    realIndex3 == activeIndex3 ? nextarrow3.style.display = 'none' : nextarrow3.style.display = 'block';
                }
                swiper3.on('slideChange', function() {
                    var realIndex3 = swiper3.realIndex;
                    var activeIndex3 = swiper3.slides.length - 5;
                    realIndex3 == 0 ? prevarrow3.style.display = 'none' : prevarrow3.style.display = 'block';
                    realIndex3 == activeIndex3 ? nextarrow3.style.display = 'none' : nextarrow3.style.display = 'block';
                });
            }
            if (ww<=764) {
                swiper3.params.slidesPerView = $(element).data('sp-slideperview') || 2.5;
                swiper3.params.spaceBetween = 0;
                var prevarrow3 = $('.prev-button-' + $(element).data('id'))[0];
                var nextarrow3 = $('.next-button-' + $(element).data('id'))[0];
                var realIndex3 = swiper3.realIndex;
                var activeIndex3 = swiper3.slides.length - 2;
                realIndex3 == 0 ? prevarrow3.style.display = 'none' : prevarrow3.style.display = 'block';
                realIndex3 == activeIndex3 ? nextarrow3.style.display = 'none' : nextarrow3.style.display = 'block';

                    if(swiper3.slides.length <= 2) {
                        nextarrow3.style.display = 'none';
                    }

                swiper3.on('slideChange', function() {
                    prevarrow3.style.display = 'none';
                    nextarrow3.style.display = 'none';
                    var realIndex3 = swiper3.realIndex;
                    var activeIndex3 = swiper3.slides.length - 2;
                    realIndex3 == 0 ? prevarrow3.style.display = 'none' : prevarrow3.style.display = 'block';
                    realIndex3 == activeIndex3 ? nextarrow3.style.display = 'none' : nextarrow3.style.display = 'block';
                });
            }
            swiper3.update();
        });
    });

    // STAFF RANKING 
    var elm4 = $('.swiper__staffranking');
    elm4.each((index, element) => {
        var swiper4 = new Swiper('.' + $(element).data('id'), {
            slidesPerView: "auto",
            spaceBetween: 0.1,
            slidesPerView: 2.5,
            preloadImages: true,
            centeredSlides: false,
            loopedSlides: 2,
            a11y: false,
            enabled: false,
            navigation: {
                nextEl: '.next-button-' + $(element).data('id'),
                prevEl: '.prev-button-' + $(element).data('id')
            },
            breakpoints: {
                768: {
                    enabled: true,
                    slidesPerView: 5,
                }
            }
        });
        $(window).resize(function(){
            var ww = $(window).width();
            if (ww>764) {
                swiper4.params.slidesPerView = 5;
                var prevarrow4 = $('.prev-button-' + $(element).data('id'))[0];
                var nextarrow4 = $('.next-button-' + $(element).data('id'))[0];
            
                prevarrow4.style.display = 'none';
                nextarrow4.style.display = 'block';

                if(ww <= 850) {
                    var realIndex4 = swiper4.realIndex;
                    var activeIndex4 = swiper4.slides.length - 5;
                    realIndex4 == 0 ? prevarrow4.style.display = 'none' : prevarrow4.style.display = 'block';
                    realIndex4 == activeIndex4 ? nextarrow4.style.display = 'none' : nextarrow4.style.display = 'block';
                }
                swiper4.on('slideChange', function() {
                    var realIndex4 = swiper4.realIndex;
                    var activeIndex4 = swiper4.slides.length - 5;
                    realIndex4 == 0 ? prevarrow4.style.display = 'none' : prevarrow4.style.display = 'block';
                    realIndex4 == activeIndex4 ? nextarrow4.style.display = 'none' : nextarrow4.style.display = 'block';
            
                });
            }
            if (ww<=764) {
                swiper4.params.slidesPerView = $(element).data('sp-slideperview') || 2.5;
                swiper4.params.spaceBetween = 0;
                var prevarrow4 = $('.prev-button-' + $(element).data('id'))[0];
                var nextarrow4 = $('.next-button-' + $(element).data('id'))[0];
                var realIndex4 = swiper4.realIndex;
                var activeIndex4 = swiper4.slides.length - 2;
                realIndex4 == 0 ? prevarrow4.style.display = 'none' : prevarrow4.style.display = 'block';
                realIndex4 == activeIndex4 ? nextarrow4.style.display = 'none' : nextarrow4.style.display = 'block';

                    if(swiper4.slides.length <= 2) {
                        nextarrow4.style.display = 'none';
                    }

                swiper4.on('slideChange', function() {
                    prevarrow4.style.display = 'none';
                    nextarrow4.style.display = 'none';
                    var realIndex4 = swiper4.realIndex;
                    var activeIndex4 = swiper4.slides.length - 2;
                    realIndex4 == 0 ? prevarrow4.style.display = 'none' : prevarrow4.style.display = 'block';
                    realIndex4 == activeIndex4 ? nextarrow4.style.display = 'none' : nextarrow4.style.display = 'block';
                });
            }
            swiper4.update();
        });
    });
    $(window).trigger('resize');
})

$(function(){
    $('.top_img').hover(
        function(){
            $(this).find('.top_text').fadeIn();
        },function(){
            $(this).find('.top_text').fadeOut();
        }
    )
});

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
